import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { Scissors } from 'lucide-react';

const API = '/api';
const RED = '#b91d47', RED_D = '#8f1538', INK = '#1c1c28', GREY = '#7a7a8c';

export default function AppHome() {
  const navigate = useNavigate();
  const [salons, setSalons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState('home');
  const [slide, setSlide] = useState(0);
  const [locName, setLocName] = useState('Nearby');
  const [coords, setCoords] = useState(null);
  const [savedIds, setSavedIds] = useState([]);

  const banners = [
    { tag: '✨ AI POWERED', h: 'Book with AI', p: 'Just type what you need', bg: 'linear-gradient(120deg,#b91d47,#d96a7a)' },
    { tag: '🎁 NEW', h: 'Style Finder', p: 'Find your perfect hairstyle', bg: 'linear-gradient(120deg,#7c3aed,#4c1d95)' },
    { tag: '🔥 OFFER', h: 'Up to 30% OFF', p: 'On your first booking', bg: 'linear-gradient(120deg,#0891b2,#065f66)' },
  ];

  useEffect(() => {
    const t = setInterval(() => setSlide(s => (s + 1) % banners.length), 3000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    try {
      const list = JSON.parse(localStorage.getItem('savedSalons') || '[]');
      setSavedIds(list.map(x => x.salon_id || x.id));
    } catch (e) {}
  }, []);

  useEffect(() => {
    // Load salons immediately with default location — don't wait for GPS.
    const fetchSalons = async (lat, lng) => {
      try {
        const r = await axios.get(`${API}/salons/nearby`, { params: { lat, lng, radius: 5 }, timeout: 12000 });
        setSalons(Array.isArray(r.data) ? r.data : (r.data?.salons || []));
      } catch (e) { setSalons([]); }
      setLoading(false);
    };

    // Start with default so UI is fast
    fetchSalons(24.95, 84.08);

    // Then try to get real location in the background
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (pos) => {
          const lat = pos.coords.latitude, lng = pos.coords.longitude;
          setCoords({ lat, lng });
          setLocName('Current location');
          fetchSalons(lat, lng); // refresh with real location
          try {
            const g = await axios.get(`${API}/geocode/reverse`, { params: { lat, lng }, timeout: 8000 });
            const area = g.data?.area || g.data?.locality || g.data?.city || g.data?.address;
            if (area) setLocName(area);
          } catch (e) { /* keep "Current location" */ }
        },
        () => setLocName('Set location'),
        { timeout: 10000, enableHighAccuracy: false }
      );
    } else {
      setLocName('Nearby');
    }
  }, []);

  const askLocation = () => {
    navigator.geolocation.getCurrentPosition(
      (pos) => window.location.reload(),
      () => toast.error('Location permission dein settings me')
    );
  };

  const cats = [
    { i: '✂️', n: 'Haircut', bg: 'linear-gradient(135deg,#fff0f0,#ffe0e0)' },
    { i: '🎨', n: 'Color', bg: 'linear-gradient(135deg,#fef3e2,#fde4c4)' },
    { i: '💆', n: 'Facial', bg: 'linear-gradient(135deg,#e8f5ff,#d0e8ff)' },
    { i: '💅', n: 'Nails', bg: 'linear-gradient(135deg,#f0e8ff,#e0d0ff)' },
    { i: '💄', n: 'Makeup', bg: 'linear-gradient(135deg,#ffe8f5,#ffd0ec)' },
    { i: '🧖', n: 'Spa', bg: 'linear-gradient(135deg,#e0fff0,#c4ffe4)' },
  ];

  return (
    <div style={{ minHeight: '100vh', background: '#fff', paddingBottom: 80, maxWidth: 480, margin: '0 auto', position: 'relative' }}>
      <style>{`
        @keyframes shimmer { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }
        @keyframes fadeUp { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: none; } }
        .fade-up { animation: fadeUp .4s ease backwards; }
      `}</style>
      {/* TOP NAV */}
      <div style={{ background: 'linear-gradient(160deg,#b91d47 0%,#d13a52 45%,#e8654f 100%)', color: '#fff', padding: '20px 20px 24px', borderRadius: '0 0 24px 24px', boxShadow: '0 8px 24px rgba(185,29,71,.22)', position: 'sticky', top: 0, zIndex: 20 }}>
        {/* Brand */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 14 }}>
          <div style={{ width: 34, height: 34, borderRadius: 10, background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
            <Scissors size={19} color="#b91d47" strokeWidth={2.5} />
            <div style={{ position: 'absolute', bottom: 1, right: 1, width: 8, height: 8, background: '#ffb800', borderRadius: '50%', border: '1.5px solid #fff' }} />
          </div>
          <span style={{ fontSize: 18, fontWeight: 800, letterSpacing: '-0.02em' }}>BookYourSalons</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 7, fontSize: 11, opacity: 0.85, marginBottom: 14, textTransform: 'uppercase', letterSpacing: '0.06em' }}>
          📍 <b onClick={askLocation} style={{ fontSize: 16, textTransform: 'none', letterSpacing: 0, cursor: 'pointer' }}>{locName}</b> ▾
          <span style={{ marginLeft: 'auto', fontSize: 21 }}>🔔</span>
        </div>
        <div style={{ fontSize: 22, fontWeight: 800, letterSpacing: '-0.02em', lineHeight: 1.2 }}>
          Hi there 👋
          <span style={{ display: 'block', fontSize: 13, fontWeight: 500, opacity: 0.85, marginTop: 4 }}>What look do you want today?</span>
        </div>
        <div onClick={() => navigate('/app/search')} style={{ marginTop: 18, background: '#fff', borderRadius: 16, display: 'flex', alignItems: 'center', gap: 10, padding: '16px', color: GREY, fontSize: 14, boxShadow: '0 10px 26px rgba(0,0,0,.16)', cursor: 'pointer' }}>
          🔍 Search salons, services... <span style={{ marginLeft: 'auto', color: RED }}>🎤</span>
        </div>
      </div>

      {/* AUTO SLIDER */}
      <div style={{ overflow: 'hidden', margin: '14px 16px 0', borderRadius: 18, position: 'relative', height: 130 }}>
        <div style={{ display: 'flex', width: '100%', height: 130, transform: `translateX(-${slide * 100}%)`, transition: 'transform .5s ease' }}>
          {banners.map((b, i) => (
            <div key={i} style={{ minWidth: '100%', height: 130, padding: 20, color: '#fff', display: 'flex', flexDirection: 'column', justifyContent: 'center', background: b.bg }}>
              <span style={{ fontSize: 9, fontWeight: 800, background: 'rgba(255,255,255,.25)', padding: '3px 9px', borderRadius: 20, width: 'fit-content', marginBottom: 8 }}>{b.tag}</span>
              <h4 style={{ fontSize: 19, fontWeight: 800, lineHeight: 1.15 }}>{b.h}</h4>
              <p style={{ fontSize: 12, opacity: 0.9, marginTop: 4 }}>{b.p}</p>
            </div>
          ))}
        </div>
        <div style={{ position: 'absolute', bottom: 10, left: 0, right: 0, display: 'flex', gap: 5, justifyContent: 'center' }}>
          {banners.map((_, i) => <i key={i} style={{ width: i === slide ? 18 : 6, height: 6, borderRadius: 3, background: i === slide ? '#fff' : 'rgba(255,255,255,.5)', transition: 'width .3s' }} />)}
        </div>
      </div>

      {/* AI FEATURE CARDS */}
      <div style={{ display: 'flex', gap: 12, padding: '16px 16px 0' }}>
        <div onClick={() => navigate('/customer')} style={{ flex: 1, background: `linear-gradient(135deg,${RED},${RED_D})`, borderRadius: 18, padding: 16, color: '#fff', cursor: 'pointer', position: 'relative', boxShadow: '0 8px 22px rgba(185,29,71,.28)' }}>
          <div style={{ fontSize: 28, marginBottom: 8 }}>🤖</div>
          <div style={{ fontSize: 15, fontWeight: 800, lineHeight: 1.15 }}>Book with AI</div>
          <div style={{ fontSize: 11, opacity: 0.9, marginTop: 3 }}>Type and book instantly</div>
          <div style={{ position: 'absolute', top: 12, right: 12, background: 'rgba(255,255,255,.25)', width: 26, height: 26, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14 }}>→</div>
        </div>
        <div onClick={() => navigate('/style-finder')} style={{ flex: 1, background: 'linear-gradient(135deg,#7c3aed,#4c1d95)', borderRadius: 18, padding: 16, color: '#fff', cursor: 'pointer', position: 'relative', boxShadow: '0 8px 22px rgba(124,58,237,.28)' }}>
          <div style={{ fontSize: 28, marginBottom: 8 }}>✨</div>
          <div style={{ fontSize: 15, fontWeight: 800, lineHeight: 1.15 }}>Style Finder</div>
          <div style={{ fontSize: 11, opacity: 0.9, marginTop: 3 }}>Best hairstyle for you</div>
          <div style={{ position: 'absolute', top: 12, right: 12, background: 'rgba(255,255,255,.25)', width: 26, height: 26, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14 }}>→</div>
        </div>
      </div>

      {/* CATEGORIES */}
      <div style={{ padding: '20px 16px 4px' }}>
        <h3 style={{ fontSize: 17, color: INK, marginBottom: 14, fontWeight: 800, letterSpacing: '-0.02em' }}>What are you looking for?</h3>
        <div style={{ display: 'flex', gap: 14, overflowX: 'auto', paddingBottom: 6 }}>
          {cats.map((c, i) => (
            <div key={i} onClick={() => navigate('/customer')} style={{ flex: '0 0 auto', textAlign: 'center', width: 64, cursor: 'pointer' }}>
              <div style={{ width: 64, height: 64, borderRadius: 20, background: c.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 28, margin: '0 auto 6px', boxShadow: '0 4px 12px rgba(185,29,71,.12)' }}>{c.i}</div>
              <span style={{ fontSize: 11, color: INK, fontWeight: 600 }}>{c.n}</span>
            </div>
          ))}
        </div>
      </div>

      {/* SALONS */}
      <div style={{ padding: '20px 16px 4px' }}>
        <h3 style={{ fontSize: 17, color: INK, marginBottom: 14, fontWeight: 800, display: 'flex', alignItems: 'center' }}>
          Salons near you
          <span onClick={() => navigate('/customer')} style={{ marginLeft: 'auto', fontSize: 12, color: RED, fontWeight: 700 }}>See all ›</span>
        </h3>

        {loading ? (
          <>
            {[1, 2].map(n => (
              <div key={n} style={{ background: '#fff', borderRadius: 18, overflow: 'hidden', marginBottom: 16, boxShadow: '0 6px 22px rgba(28,28,40,.06)' }}>
                <div style={{ height: 160, background: 'linear-gradient(90deg,#f0f0f4 25%,#e8e8ee 50%,#f0f0f4 75%)', backgroundSize: '200% 100%', animation: 'shimmer 1.3s infinite' }} />
                <div style={{ padding: '12px 14px', display: 'flex', gap: 10, alignItems: 'center' }}>
                  <div style={{ width: 50, height: 22, borderRadius: 7, background: 'linear-gradient(90deg,#f0f0f4 25%,#e8e8ee 50%,#f0f0f4 75%)', backgroundSize: '200% 100%', animation: 'shimmer 1.3s infinite' }} />
                  <div style={{ width: 80, height: 16, borderRadius: 6, background: 'linear-gradient(90deg,#f0f0f4 25%,#e8e8ee 50%,#f0f0f4 75%)', backgroundSize: '200% 100%', animation: 'shimmer 1.3s infinite' }} />
                </div>
              </div>
            ))}
          </>
        ) : salons.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 40, color: GREY, fontSize: 14 }}>
            No salons found nearby.<br />Please try again later.
          </div>
        ) : (
          salons.slice(0, 6).map((s, i) => (
            <div key={i} onClick={() => {
              const sid = s.salon_id || s.id;
              sessionStorage.setItem('app_salon_' + sid, JSON.stringify(s));
              navigate('/app/salon/' + sid);
            }} className="fade-up" style={{ background: '#fff', borderRadius: 18, overflow: 'hidden', boxShadow: '0 6px 22px rgba(28,28,40,.08)', cursor: 'pointer', marginBottom: 16, animationDelay: `${i * 0.07}s` }}>
              <div style={{ height: 160, background: s.photo_url ? `url(${s.photo_url}) center/cover` : 'linear-gradient(135deg,#e2c4b8,#c99d8a)', position: 'relative' }}>
                <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top,rgba(0,0,0,.55),transparent 55%)' }} />
                <div onClick={(e) => {
                  e.stopPropagation();
                  try {
                    const list = JSON.parse(localStorage.getItem('savedSalons') || '[]');
                    const sid = s.salon_id || s.id;
                    const exists = list.some(x => (x.salon_id || x.id) === sid);
                    const next = exists ? list.filter(x => (x.salon_id || x.id) !== sid) : [...list, s];
                    localStorage.setItem('savedSalons', JSON.stringify(next));
                    setSavedIds(next.map(x => x.salon_id || x.id));
                    toast.success(exists ? 'Removed from saved' : 'Saved!');
                  } catch (err) {}
                }} style={{ position: 'absolute', top: 12, right: 12, width: 34, height: 34, background: 'rgba(255,255,255,.92)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 17, color: RED, zIndex: 2 }}>
                  {savedIds.includes(s.salon_id || s.id) ? '♥' : '♡'}
                </div>
                <div style={{ position: 'absolute', bottom: 12, left: 12, color: '#fff' }}>
                  <div style={{ fontSize: 18, fontWeight: 800, letterSpacing: '-0.02em' }}>{s.salon_name || s.name || 'Salon'}</div>
                  <div style={{ fontSize: 12, opacity: 0.9, marginTop: 2 }}>{s.business_type === 'parlour' ? 'Parlour' : 'Salon'}</div>
                </div>
              </div>
              <div style={{ padding: '12px 14px', display: 'flex', alignItems: 'center', gap: 10 }}>
                <span style={{ background: '#22a06b', color: '#fff', fontSize: 12, fontWeight: 800, padding: '3px 8px', borderRadius: 7 }}>{s.rating || '4.2'} ★</span>
                <span style={{ fontSize: 12, color: GREY }}>{s.distanceKm ? `${s.distanceKm.toFixed(1)} km` : 'Near you'}</span>
              </div>
            </div>
          ))
        )}
      </div>

      {/* TRUST */}
      <div style={{ padding: '20px 16px 0' }}>
        <h3 style={{ fontSize: 17, color: INK, marginBottom: 14, fontWeight: 800 }}>Why BookYourSalons?</h3>
      </div>
      <div style={{ display: 'flex', gap: 10, padding: '0 16px 4px', overflowX: 'auto' }}>
        {[['10k+', 'Happy customers'], ['4.6★', 'Average rating'], ['2 min', 'Quick booking'], ['100%', 'Verified salons']].map((t, i) => (
          <div key={i} style={{ flex: '0 0 auto', width: 150, background: '#fdf2f5', borderRadius: 16, padding: 16 }}>
            <div style={{ fontSize: 26, fontWeight: 800, color: RED, letterSpacing: '-0.03em' }}>{t[0]}</div>
            <div style={{ fontSize: 12, color: GREY, marginTop: 4 }}>{t[1]}</div>
          </div>
        ))}
      </div>

      <div style={{ textAlign: 'center', padding: 20, color: GREY, fontSize: 12 }}>
        <div style={{ fontWeight: 800, color: RED, fontSize: 15, marginBottom: 4 }}>💈 BookYourSalons</div>
        Made with ❤️ in India 🇮🇳
      </div>

      {/* BOTTOM TABS */}
      <div style={{ position: 'fixed', bottom: 0, left: '50%', transform: 'translateX(-50%)', width: '100%', maxWidth: 480, height: 68, background: '#fff', borderTop: '1px solid #f0f0f4', display: 'flex', zIndex: 30, boxShadow: '0 -4px 20px rgba(0,0,0,.06)' }}>
        {[['home', '🏠', 'Home'], ['search', '🔍', 'Search'], ['bookings', '📅', 'Bookings'], ['account', '👤', 'Account']].map(([k, ic, lbl]) => (
          <div key={k} onClick={() => { setTab(k); if (k === 'account') navigate('/app/profile'); if (k === 'bookings') navigate('/app/bookings'); if (k === 'search') navigate('/app/search'); }}
            style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 3, fontSize: 10, color: tab === k ? RED : GREY, cursor: 'pointer', fontWeight: 600 }}>
            <span style={{ fontSize: 21 }}>{ic}</span>{lbl}
          </div>
        ))}
      </div>
    </div>
  );
}
